import React from 'react';
import {
  FDLozenge, FDPaper, FDStack, FDTitleText,
} from '@facet-wealth/design';
import PropTypes from 'prop-types';
import ManagedAccountPortfolioBarChart
  from 'Views/Page/Content/Templates/ManagedAccountPageTemplate/Content/ManagedAccountPageTabPanel/Layouts/AccountPerformanceDashboard/PortfolioSection/ManagedAccountPortfolioBarChart';
import { dataAttrs } from 'Helpers/Testing';
import useMobileLayout from 'Hooks/useMobileLayout';


const InvestmentMixCard = ({ investmentMixChartData, isUpdated = false, attributes = [] }) => {
  const isMobile = useMobileLayout();
  const lozengeColor = isUpdated ? 'success' : 'subtle';
  const lozengeLabel = isUpdated ? 'Updated' : 'Current';
  return (
    <FDPaper color={isUpdated ? 'success' : 'subtle'} padding={3} minWidth={300} flexGrow={1} {...dataAttrs(`investment-mix-card-${isUpdated ? 'updated' : 'current'}`)}>
      <FDStack direction={'column'} spacing={2}>
        <FDStack direction={'row'} spacing={2} alignItems={'center'}>
          <FDLozenge color={lozengeColor} label={lozengeLabel} size={'lg'} {...dataAttrs('investment-mix-card-status-lozenge', { 'data-value': lozengeLabel })} />
          {!isMobile && <FDTitleText size={'lg'} value={'Investment Mix'} />}
          <FDStack direction={'row'} spacing={1} flexGrow={1} alignItems={'center'} justifyContent={'flex-end'}>
            {attributes.map((attribute) => (
              <FDLozenge key={attribute} color={lozengeColor} label={attribute} size={'lg'} {...dataAttrs(`investment-mix-card-model-attribute-lozenge-${attribute}`)} />
            ))}
          </FDStack>
        </FDStack>
        <ManagedAccountPortfolioBarChart allocationModelClassifications={investmentMixChartData} simple />
      </FDStack>
    </FDPaper>
  );
};

InvestmentMixCard.propTypes = {
  isUpdated: PropTypes.bool,
  investmentMixChartData: PropTypes.array.isRequired,
  attributes: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export { InvestmentMixCard };
